@if (operation) {
<tec-collapse
    [icon]="'icon-file'"
    [title]="'PROCESSES.DETAIL.DOCUMENTS' | translate"
    [tags]="[
        {
            label: ('MASTER.STATUS.' + operation.state | translate),
            status: masterService.getTagStatus(operation.state)
        }
    ]"
    [expanded]="expanded"
    (clickEvent)="toggleCollapse?.emit($event)"
>
    <app-developer-curl-button
        ngProjectAs="tec-button-icon"
        [path]="operationCurlPath"
        titleKey="PROCESSES.CURL_MODAL.TITLE_OPERATION"
    />
    @if (operation.state !== OPERATION_STATUS.INIT && operation.state !== OPERATION_STATUS.NOT_STARTED) {
        @if (operation?.document?.length > 0) {
        <tec-tile [title]="'PROCESSES.DETAIL.DETAILS' | translate">
            @for (doc of operation?.document; track $index) {
                <app-operation-document-list-item [doc]="doc" (open)="openDocument($event)" />
            }
        </tec-tile>
        }

        <tec-tile [title]="'PROCESSES.DETAIL.OPERATION' | translate">
            <div class="grid grid-i3">
                <tec-info-group [label]="'PROCESSES.DETAIL.ID_OPERATION' | translate">
                    <!-- Comentado hasta que tengamos el detalle de la operación
                    <span>{{ truncateUUID(operation.uuid) ?? ('GENERAL.NOT_AVAILABLE' | translate) }}</span>
                    <tec-button-icon icon="icon-eye" size="sm" (click)="goToOperation(operation.uuid)" />
                    -->
                    <tec-copy-text
                        [label]="processHelper.truncateUUID(operation.uuid)"
                        [labelToCopy]="operation.uuid"
                    ></tec-copy-text>
                </tec-info-group>
            </div>

            <tec-divider />

            <div class="grid grid-i3">
                <tec-info-group [label]="'PROCESSES.DETAIL.START_DATE' | translate">
                    <tec-icon name="icon-calendar" size="xs" />
                    <span>{{ formatDate(operation.start_at) }}</span>
                </tec-info-group>
                <tec-info-group [label]="'PROCESSES.DETAIL.END_DATE' | translate">
                    <tec-icon name="icon-calendar" size="xs" />
                    <span>{{ formatDate(operation.end_at) }}</span>
                </tec-info-group>
                <tec-info-group [label]="'PROCESSES.DETAIL.DURATION' | translate">
                    <tec-icon name="icon-clock" size="xs" />
                    <span>{{ formatDuration(operation.total_time) }}</span>
                </tec-info-group>
            </div>
        </tec-tile>
        @if (operation.uuid) {
            <tec-button
                [label]="'PROCESSES.DETAIL.SEE_OPERATION' | translate"
                (clickEvent)="goToOperationDetail(operation.uuid, $event)"
            />
        }
    } @else {
        <tec-empty-state
            [title]="'GENERAL.NO_DATA' | translate"
            [size]="'default'"
            [type]="'empty'"
        ></tec-empty-state>
    }
</tec-collapse>
}
